module.exports = __webpack_public_path__ + "media/xianhuokucun.45b50e33.mp3";